import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { LocaleService } from './core/services/locale/locale.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'irembogov-root',
  templateUrl: './app.component.html',
  // Bootstrapped by AppModule, so it must remain an NgModule-declared component.
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'agent-portal';
  private navSub: Subscription | undefined;
  isLoadingTranslations = false;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private localeService: LocaleService,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang(
      localStorage.getItem('locale') ?? environment.DEFAULT_LOCALE
    );
  }

  ngOnInit(): void {
    this.localeService.loadingTranslations.subscribe(status => {
      this.isLoadingTranslations = status;
    });

    this.navSub = this.router.events.subscribe((event: unknown) => {
      if (event instanceof NavigationEnd) {
        this.modalService.dismissAll();
      }
    });
  }

  ngOnDestroy(): void {
    this.navSub?.unsubscribe();
  }
}
